import React from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  return (
    <nav
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: 'red',  // Navbar background
        padding: '10px 20px',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
      }}
    >

      {/* Left Side Logo + Brand Name */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          color: '#fff',
          fontSize: '20px',
          fontWeight: 'bold',
        }}
      >
        <img
          src="/images/Logo.jpg"  // Your logo from public/images
          alt="logo"
          style={{ width: '40px', height: '40px' }}
        />
        Return Gift Studio
      </div>

      {/* Right Side Navigation Links */}
      <div style={{ display: 'flex', gap: '20px' }}>
        <Link style={{ color: '#fff', textDecoration: 'none' }} to="/">Home</Link>
        <Link style={{ color: '#fff', textDecoration: 'none' }} to="/return-gifts">Return Gifts</Link>
        <Link style={{ color: '#fff', textDecoration: 'none' }} to="/new-arrivals">New Arrivals</Link>
      </div>
    </nav>
  );
};

export default Navbar;
